module.exports = __webpack_public_path__ + "static/img/hussar_select_face.59eb427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_select_face.jpg
// module id = zo2b
// module chunks = 0